import "./style.css";

import funcionario1img from "../../images/ourteam/funcionario1.jpeg";
import funcionario2img from "../../images/ourteam/funcionario2.jpeg";
import funcionario3img from "../../images/ourteam/funcionario3.jpeg";

export default function OurTeam(){
  const employees = [
    {
      id: 1,
      name: "Jessica Castro",
      imgUrl: funcionario1img,
      cargo: ["Cabeleireira", "Designer de sobrancelha"],
    },
    {
      id: 2,
      name: "Gerusa Santos",
      imgUrl: funcionario2img,
      cargo: ["Cabeleireira", "Colorimetrista"],
    },
    {
      id: 3,
      name: "Maria Rita",
      imgUrl: funcionario3img,
      cargo: ["Cabeleireira", "Depiladora"],
    },
  ];

  return(
    <div className="ourteam-container">
      {/* <span>Saiba quem são as mentes por trás disso</span> */}
      <h2>Conheça nossa equipe</h2>
      <div className="ourteam-employees">
        {employees.map((x) => (
          <div className="employess-card">
            <img src={x.imgUrl} alt={x.name}/>
            <h2>{x.name}</h2>
            <div className="employess-role-container">
              {x.cargo.map((role, index) => (
                <span key={index} className="employess-role">{role}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};